import { Directive } from '@angular/core';

@Directive({
  selector: '[pxwCardFooter]',
  standalone: true,
})
export class CardFooterDirective {}
